import { render, staticRenderFns } from "./TagDigitalImage.vue?vue&type=template&id=4980b40c"
import script from "./TagDigitalImage.vue?vue&type=script&lang=js"
export * from "./TagDigitalImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports